import React, { Component } from 'react';
import book from './img/book.jpg';
import amznLogo from './img/amazon-logo-transparent.png';
import bioImg from './img/doug-dold.jpg';
import './App.css';

class App extends Component {
  render() {
    return (
      <section className="section main">
        <div className="App">
          <section className="header">
            <div className="title-section container">
              <h1>
                Lawyered <span>Up</span>
              </h1>
              <h6>A Novel by Doug Dold</h6>
            </div>
            <div className="hero container">
              <div className="columns">
                <div className="column book is-one-third">
                  <a
                    href="http://a.co/b3Z56Ba"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="main-book"
                  >
                    <img src={book} alt="Lawyered Up" />
                  </a>
                  <p>
                    <span>Click below to buy the book:</span>
                    <a
                      href="http://a.co/b3Z56Ba"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="amzn-link"
                    >
                      <img src={amznLogo} width="133" height="40" alt="Amazon" />
                    </a>
                  </p>
                </div>
                <div className="column synopsis">
                  <p className="lead">
                    Unexpected things can occur in the practice of law: some
                    good, some bad, some very bad.
                  </p>
                  <p>
                    <strong>
                      <span className="big">J</span>ack Hamilton
                    </strong>{' '}
                    is an attorney specializing in business law. His firm,
                    Hamilton, Murphy & Associates, is confronted by financial
                    difficulties in the Great Recession of 2009, when a
                    significant client, <strong>Marty Waldecker</strong>, is
                    murdered. The feds had taken a strong interest in illicit
                    activities of Waldecker, as well as another important
                    client, <strong>Claude Malverne</strong>. Could Jack and his
                    tiny law firm be implicated?
                  </p>
                  <p>
                    <strong>
                      <span className="big">C</span>laude
                    </strong>{' '}
                    is aging when he imports a beautiful young internet bride
                    from Russia. The battle over money ensues when the ambitious{' '}
                    <strong>Svetlana</strong> retains aggressive lawyers to
                    defeat the claims of Claude's entitled kids. Claude's wealth
                    is worthy of the fight and everyone is <em>Lawyered Up</em>.
                    Rules of ethics are often ignored with impunity. Jack and
                    his partner hire a brilliant, albeit nerdy, young attorney
                    named <strong>Theo Karakas</strong> to assist in finding a
                    solution to the war being fought on multiple fronts. In the
                    midst of the fray, Jack and his wife, <strong>Ellen</strong>,
                    endure a personal crisis. Jack manages to maintain his sense
                    of humor despite the ongoing challenges, and learns much
                    about himself on the arduous, and at times perilous,
                    journey.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="about section">
            <div className="container">
              <div className="columns secondary">
                <div className="column bio is-two-thirds">
                  <p>
                    Douglas H. Dold was born in Toledo, Ohio and did his
                    undergraduate studies at the University of Michigan. He
                    attended law school in Detroit at the school now known as
                    Michigan State University College of Law. During this period
                    he became a Certified Public Accountant working for Deloitte
                    in the tax department of its Detroit office.
                  </p>
                  <p>
                    Doug has practiced business and estate law for more than 40
                    years in the Detroit area. Having traversed many difficult
                    situations and witnessed the tactics and antics of lawyers
                    and others, he began to nurture thoughts of writing a novel.
                    This commonplace behavior would prove to be fertile ground
                    for developing characters and events for the story.
                  </p>
                  <p>
                    In October, 2010, Doug completed a business transaction with
                    an attorney who was assassinated several days later. There
                    were millions of dollars of insurance on the life of the
                    attorney and a legal battle commenced over the money. These
                    experiences culminated in Doug undertaking the challenge of
                    writing a novel, and <em>Lawyered Up</em> is the result.
                  </p>
                </div>
                <div className="column headshot">
                  <img src={bioImg} alt="Doug Dold" />
                </div>
              </div>
            </div>
          </section>
          <section className="footer">
            <div className="container">
              <p className="disclaimer">
                <em>Disclaimer:</em> Although the Author's practice of law for
                more than forty years has provided many of the ideas and
                concepts regarding characters and events for this story, this
                book is a work of fiction. Names, characters, places, and
                incidents either are products of the Author's imagination or are
                used fictitiously. Any resemblance to actual events or people,
                living or dead, is coincidental.
              </p>
              <p className="credits">
                &copy; Doug Dold {new Date().getFullYear()}
              </p>
            </div>
          </section>
        </div>
      </section>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js